import './bootstrap';
import { createApp } from 'vue';
import VueEasyLightbox from 'vue-easy-lightbox';
import Cases from './components/Cases.vue';

const app = createApp({
    components: { Cases },
});
app.use(VueEasyLightbox);
app.mount('#cases');
